/* Filthy Clean — /cart page enhancements.

   SCOPE WARNING: Tinker's own cart drawer and the Rebuy Smart Cart drawer share
   class names with the cart page (.cart-summary, .cart__ctas, .cart-totals,
   cart-items-component). Only the PAGE has .cart-page, so every lookup below
   starts from that element. Nothing here may touch a drawer — the drawers are
   already done and are configured elsewhere (Rebuy admin).

   What it adds:
   1. Free-delivery progress meter at the top of the summary panel.
   2. Reassurance list under the checkout button.
   3. A clearer checkout button label.
   4. A real CTA on the empty-cart state.
   5. Cross-sell row: hides products already in the cart, caps the row at 4.

   The theme re-renders .cart-page__items and .cart-page__summary on every
   quantity change, so everything is re-applied on cart update and on a
   MutationObserver, and every write is idempotent. */
(function () {
  'use strict';

  if (!document.querySelector('.cart-page')) return;

  /* Wholesale buyers (html.fc-b2b, set in header-group.json) get the wholesale
     freight terms, free from A$500 (GST-inclusive, like their prices), and no
     money-back line, because the retail guarantee doesn't cover wholesale orders
     (terms 14.3). Everyone else: A$100, matching the announcement bar.
     Subscriptions ship free at any value via the Kedra Checkout Rules shipping rule. */
  var B2B = document.documentElement.classList.contains('fc-b2b');
  var FREE_SHIP_CENTS = B2B ? 50000 : 10000;
  var SHOP_URL = '/collections/non-toxic-natural-cleaning-products';
  /* Bare word only — fc-dopamine.css §29 draws the arrow as a masked ::after on the button,
     so it stays vertically centred instead of sitting on the text baseline. */
  var CHECKOUT_LABEL = 'Checkout';
  var CROSS_SELL_MAX = 4;

  var TRUST_HTML = B2B
    ? '<ul class="fc-trust">' +
      '<li>Free delivery on orders of $500 or more</li>' +
      '<li>Secure, encrypted checkout</li>' +
      '</ul>'
    : '<ul class="fc-trust">' +
      '<li>30 day Filthy-Free or Free guarantee</li>' +
      '<li>Free delivery on orders over $100</li>' +
      '<li>Secure, encrypted checkout</li>' +
      '</ul>';

  var state = { total: null, hasSub: false, handles: [] };
  var busy = false;
  var timer = null;

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  /* ---- 1. free-delivery meter ---- */
  function upsertMeter(page) {
    if (state.total === null) return;
    var summary = page.querySelector('.cart-page__summary');
    if (!summary) return;

    var el = summary.querySelector('.fc-ship');
    if (!el) {
      var host = summary.querySelector('.cart-summary__inner') || summary;
      host.insertAdjacentHTML(
        'afterbegin',
        '<div class="fc-ship"><p class="fc-ship__msg" role="status"></p>' +
          '<div class="fc-ship__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" ' +
          'aria-label="Progress towards free delivery"><span class="fc-ship__fill"></span></div></div>'
      );
      el = summary.querySelector('.fc-ship');
    }

    var remaining = FREE_SHIP_CENTS - state.total;
    var pct = Math.max(0, Math.min(100, Math.round((state.total / FREE_SHIP_CENTS) * 100)));
    var msg;

    if (state.hasSub) {
      pct = 100;
      msg = '<strong>Delivery is on us.</strong> Subscriptions always ship free.';
    } else if (remaining <= 0) {
      pct = 100;
      msg = '<strong>Free delivery unlocked.</strong> Nice work.';
    } else {
      msg = '<strong>' + money(remaining) + ' to go</strong> and delivery is on us.';
    }

    el.classList.toggle('is-done', pct === 100);
    el.querySelector('.fc-ship__msg').innerHTML = msg;
    el.querySelector('.fc-ship__track').setAttribute('aria-valuenow', pct);
    el.querySelector('.fc-ship__fill').style.width = pct + '%';
  }

  /* ---- 2 + 3. reassurance list and checkout label ---- */
  function upsertSummaryChrome(page) {
    var ctas = page.querySelector('.cart__ctas');
    if (ctas && !ctas.parentNode.querySelector('.fc-trust')) {
      ctas.insertAdjacentHTML('afterend', TRUST_HTML);
    }

    var label = page.querySelector('.cart__checkout-button .button-text');
    if (label && label.textContent.trim() !== CHECKOUT_LABEL) {
      label.textContent = CHECKOUT_LABEL;
    }
  }

  /* ---- 4. empty-cart CTA ---- */
  function upsertEmptyState(page) {
    var isEmpty = page.classList.contains('cart-page--empty');
    var block = page.querySelector('.fc-cart-empty');

    if (isEmpty && !block) {
      var title = page.querySelector('.cart-page__title');
      if (title) {
        title.insertAdjacentHTML(
          'afterend',
          '<div class="fc-cart-empty">' +
            '<p>Nothing in here but good intentions.</p>' +
            '<a class="button fc-cart-empty__cta" href="' + SHOP_URL + '">Shop the sheets</a>' +
            '</div>'
        );
      }
    } else if (!isEmpty && block) {
      block.remove();
    }
  }

  /* ---- 5. cross-sell row ---- */
  function filterCrossSell() {
    var sec = document.querySelector('[id$="__product_list_fccart"]');
    if (!sec) return;

    var shown = 0;
    var items = sec.querySelectorAll('.resource-list__item');

    for (var i = 0; i < items.length; i++) {
      var link = items[i].querySelector('a[href*="/products/"]');
      var handle = '';
      if (link) {
        handle = (link.getAttribute('href').split('/products/')[1] || '').split(/[?#]/)[0];
      }
      var inCart = handle !== '' && state.handles.indexOf(handle) !== -1;
      var hide = inCart || shown >= CROSS_SELL_MAX;
      items[i].hidden = hide;
      if (!hide) shown++;
    }

    /* No suggestions left (every product already in the cart) — drop the row
       rather than leave an empty heading stranded above the guarantee strip. */
    sec.hidden = items.length > 0 && shown === 0;
  }

  function enhance() {
    var page = document.querySelector('.cart-page');
    if (!page || busy) return;

    busy = true;
    try {
      upsertEmptyState(page);
      upsertMeter(page);
      upsertSummaryChrome(page);
      filterCrossSell();
    } finally {
      setTimeout(function () {
        busy = false;
      }, 0);
    }
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        state.total = cart.total_price;
        state.hasSub = items.some(function (i) {
          return !!i.selling_plan_allocation;
        });
        state.handles = items.map(function (i) {
          return i.handle;
        });
        enhance();
      })
      .catch(function () {
        /* leave the meter out rather than show a wrong number */
      });
  }

  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 250);
  }

  refresh();

  document.addEventListener('shopify:cart:lines-update', scheduleRefresh);

  var host = document.querySelector('.cart-page');
  host = host && host.closest('cart-items-component');
  if (host && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (busy) return;
      enhance();
      scheduleRefresh();
    }).observe(host, { childList: true, subtree: true });
  }
})();
